<template lang="pug">
.main
  div.d-flex.mt-4.align-center
    v-img.mt-2.ml-2(:src="require('@/assets/images/logo_main.png')" max-height="40" max-width="100" contain)
    v-spacer
    v-menu(:offset-y='true')
      template(v-slot:activator='{ on }')
        v-btn.button-Aa-medium.mr-1(text v-on="on" small)
          span {{ selectedLang.name }}
          v-card.ml-2(tile)
            v-img(:src="require(`@/assets/images/flags/${selectedLang.flag}.png`)" width="26px" height="14px")
      v-list
        template(v-for="lang in languages")
          v-list-item(dense :key='lang.code' @click="language = lang.code")
            v-list-item-title(v-text="lang.name")
            v-list-item-icon(v-if="lang.code === language")
              v-icon(color="success" v-text="'mdi-check-bold'")

  v-layout(style="height:90vh")
    v-container.white.lighten-4.my-auto(style="max-width: 600px;" :class="{'mx-0 px-0': this.$vuetify.breakpoint.xs}")
      h3.text-center.mt-8.mb-4.grey--text.text--darken-3(v-if="company && !this.$isLandingPage") {{ $t('sign_in_to') }} {{ company.name }}
      v-card.mt-4.mx-3.pb-6(v-if="step === 1" outlined :tile="$vuetify.breakpoint.xs" :class="{'px-8': !$vuetify.breakpoint.xs}")
        h5.text-center.my-8.primary--text {{ $t('log_in_to') }} Yezza
        v-card-text.pt-0(:class="{'pb-0': $vuetify.breakpoint.xs}")
          template(v-if="!$isMobile")
            v-btn.mb-4.font-weight-bold.button-AA-medium.white--text(color="info500" x-large block depressed @click="continueGoogleSignIn" height="40" :loading="googleSignInLoading")
              v-icon(left small) mdi-google
              | {{ $t('log_in_with_google') }}
            div.text-center.mb-4 {{ $t('or') }}
          v-text-field.mb-4(color="primary" v-model="phoneEmail" hide-details outlined @keyup.enter="continueSignIn" :disabled="emailInputDisabled" dense solo flat background-color="basic200" height="40")
            template(v-slot:label)
              .p1.basic600--text {{ $t('enter_phone_number_email') }}
          v-btn.mb-4.font-weight-bold.button-AA-medium.white--text(color="info500" x-large block depressed @click="continueSignIn" :loading="loading" height="40") {{ $t('log_in') }}
          .p2.text-center.primary400--text.mb-2 {{ $t('you_will_receive_email_sms') }}
      //- .language-selector.mx-3.mt-8(v-if="step === 1")
        .label.basic600--text.text-uppercase {{ $t('your_language') }}
        v-select.mt-2(v-model="language" :items="languages" item-text="name" item-value="code" outlined dense background-color="basic200" height="40")
      div.mt-4.text-center(v-if="step === 1")
        h6.c2.text-center(style="color: #848484; font-weight:600;") {{ $t('new_to_yezza') }}
          span.cursor-pointer.info500--text(v-if="!user" text @click="$router.push('/signup')")  {{ $t('sign_up_now') }}
      div.mx-3(v-if="step === 2")
        v-alert(color="info500")
          v-row
            v-col.pr-0(cols="3")
              v-card.text-center.align-center.justify-center(flat style="width:40px ; height;40px")
                eva-icon.pt-1(name="email-outline" :fill="$vuetify.theme.themes[$theme].info500")
            v-col.pl-0.text-left.align-left(cols="9")
              h6.s1.white--text {{ $t('check_email_inbox') }}
              h6.c1.white--text {{ $t('check_email_inbox_desc') }}
      v-card.mt-4.px-2.py-4.mx-3(v-if="step === 2" outlined :tile="$vuetify.breakpoint.xs")
        v-card-text(:class="{'pb-0': $vuetify.breakpoint.xs}")
          p.mb-1.label.basic600--text.text-uppercase {{ $t('email_address') }}
          v-text-field.p1.pt-2(color="basic500" v-model="form.email" label="E-mail address" hide-details outlined disabled dense solo flat background-color="basic200" height="40")
            eva-icon(slot="append" name="checkmark-circle-2-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].success400")
          template(v-if="emailAuthInProgress")
            v-layout.my-4(v-if="emailAuthWaiting")
              div.mx-auto
                v-layout
                  v-progress-circular.my-auto(indeterminate :size="16" :width="2" color="info500")
                  .p2.my-auto.ml-3 {{ $t('waiting_for_your_approval') }}...
            div(v-else)
              v-layout.my-4(v-if="emailAuthSuccess")
                div.mx-auto
                  v-layout
                    eva-icon.mb-n1(name="checkmark-circle-2-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].success400")
                    .p2.ml-3.my-auto {{ $t('sign_in_approved_continue_in') }} {{emailAuthCloseTimer}}...
              v-layout.my-4(v-else)
                div.mx-auto
                  v-layout
                    eva-icon.mb-n1(name="close-circle-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].danger500")
                    .p2.ml-3.my-auto {{ $t('approval_link_expired') }},&nbsp;
                      a.info500--text.cursor-pointer(@click="requestEmailAuthLink") {{ $t('click_here_to_request') }}
                      | .
          v-divider.mt-12.mb-n3
          v-layout.mb-8
            div.mx-auto.px-3.basic100
              .s2.primary400--text {{ $t('or') }}
          v-layout
            label.basic600--text.text-uppercase {{ $t('log_in_with_password') }}
            v-spacer
            .c1(@click="$router.push({ name: 'Forgot', params: { signInEmail: form.email } })") {{ $t('forgot_password') }}
          v-text-field.pt-2(color="primary" v-model="form.password" type="password"  @keyup.enter="passwordSignIn" persistent-hint outlined dense solo flat background-color="basic200"    height="40")
            template(v-slot:label)
              .p1.basic600--text {{ $t('password') }}
          v-btn.mb-4.button-AA-medium.white--text(color="info500" x-large block depressed @click="passwordSignIn" :loading="passwordSignInLoading") {{ $t('log_in') }}
      div.mx-6.mt-10.text-center(v-if="step === 2")
        a.button-Aa-small.primary400--text(@click="step--") &#8592; {{ $t('back') }}
  .modals
    y-dialog(v-model='phoneAuthInProgress' persistent width='300')
      v-card(v-if="phoneAuthWaiting" color='primary' dark)
        v-card-text.pt-3
          p.mt-2 {{ $t('check_your_phone') }} {{phoneEmail}}.
          v-progress-linear.my-4(indeterminate='', color='white')
          p.mb-0.caption {{ $t('waiting_for_your_approval') }}...
        v-card-actions
          v-spacer
          v-btn(text :disabled="resendOTPTimer > 0" @click="requestPhoneAuthLink")
            span(v-if="resendOTPTimer > 0") {{ $t('resend') }} ({{ resendOTPTimer}})
            span(v-else) {{ $t('resend') }}
      template(v-else)
        v-card(v-if="phoneAuthSuccess" color='success' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('sign_in_approved') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('continue_in') }} {{phoneAuthCloseTimer}}...

        v-card(v-else color='error' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('sign_in_not_approved') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('closing_in') }} {{phoneAuthCloseTimer}}...
</template>

<script>
import Cookies from 'js-cookie'
import { mapState, mapGetters, mapActions } from 'vuex'
import TopBar from '@/components/TopBar.vue'
import {isMarketingMerchantApp} from "@/utils";

export default {
  name: "SignIn",
  components: { TopBar },
  props: ['fillEmail', 'invitation'],
  data: (vm) => ({
    loading: false,
    googleSignInLoading: false,
    passwordSignInLoading: false,
    step: 1,
    emailInputDisabled: false,
    phoneEmail: vm.fillEmail,
    form: {
      email: '',
      password: '',
    },
    phoneAuthInProgress: false,
    phoneAuthWaiting: false,
    phoneAuthSuccess: false,
    phoneAuthProgressTimer: 0,
    phoneAuthCloseTimer: 0,
    resendOTPTimer: 0,
    emailAuthInProgress: false,
    emailAuthWaiting: false,
    emailAuthSuccess: false,
    emailAuthProgressTimer: 0,
    emailAuthCloseTimer: 0,
    language: null,
    languages: [
      { name: 'English', code: 'en', flag: 'gb' },
      { name: 'Bahasa Indonesia', code: 'id', flag: 'id' },
    ],
    authLinkRecheckCount: 0,
    manualCheckInterval: null,
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      lang: 'language/getLanguage'
    }),
    authMethod () {
      if (this.phoneEmail) {
        return this.phoneEmail.includes('@') ? 'email': 'phone'
      } else {
        return 'phone'
      }
    },
    selectedLang () {
      let lang = this.languages.find(f => f.code === this.language)
      return lang || { name: 'English', code: 'en', flag: 'gb' }
    },
    isMarketingMerchantApp () {
      return isMarketingMerchantApp(this.$route)
    }
  },
  watch: {
    phoneAuthCloseTimer (val) {
      if (val === 0) {
        this.phoneAuthInProgress = false
      }
    },
    language (val) {
      if (!val || val === 'undefined' || val === 'null') {
        this.$store.commit('language/setLanguage', 'en')
        this.language = 'en'
      } else {
        this.$store.commit('language/setLanguage', val)
      }
    }
  },
  mounted () {
    if (this.$subdomain && this.$subdomain !== 'app') {
      window.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`
    }

    if (this.user) {
      if (this.isMarketingMerchantApp) {
        this.$router.push('/companies/merchant-app')
        return
      }
      this.$router.push('/companies')
      return
    }

    // SignUp Type
    const signupType = this.$route.query.signuptype
    if (signupType) {
      localStorage.setItem('signup-type', signupType)
    }

    if (this.invitation) {
      if (this.invitation.email) {
        this.phoneEmail = this.invitation.email
        this.emailInputDisabled = true
      } else if (this.invitation.phone) {
        this.phoneEmail = this.invitation.phone
        this.emailInputDisabled = true
      }
    }
    this.handleParamUrl()
    this.handleGoogleSignInCallback()

    this.language = this.lang
  },
  methods: {
    ...mapActions(['showMessage']),
    continueGoogleSignIn () {
      let redirectSigninUrl = '/signin'
      if (this.isMarketingMerchantApp) {
        redirectSigninUrl = '/signin/merchant-app'
      }
      const redirectUri = window.location.origin + redirectSigninUrl
      const nonce = (Math.random() + 1).toString(36).substring(2)
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.VUE_APP_GOOGLE_CLIENT_ID}&redirect_uri=${redirectUri}&state=google&response_type=id_token&nonce=${nonce}&scope=profile email`
    },
    continueSignIn () {
      if (!this.phoneEmail) {
        return
      }
      if (this.authMethod === 'phone') {
        this.phoneSignIn()
      } else if (this.authMethod === 'email') {
        this.emailSignIn()
      }
    },
    async phoneSignIn () {
      this.loading = true
      try {
        let resp = await this.$axios.get(`/users/check_phone/?phone=${encodeURIComponent(this.phoneEmail)}`)
        if (!resp.data.available) {
          this.requestPhoneAuthLink()
        } else {
          this.showMessage(['error', this.$t('error_message.no_account_found_phone_number'), this.$t('error_message.check_number_logging_email')])
        }
      } catch {
        this.showMessage(['error', this.$t('error_message.no_account_found_phone_number'), this.$t('error_message.check_number_logging_email')])
      } finally {
        this.loading = false
      }
    },
    async emailSignIn () {
      this.loading = true
      try {
        let resp = await this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.phoneEmail)}`)
        if (!resp.data.available) {
          if (resp.data.verified) {
            this.form.email = this.phoneEmail
            this.step = 2
            this.requestEmailAuthLink()
          } else {
            this.showMessage(['error', this.$t('error_message.this_email_must_verified')])
          }
        } else {
          this.showMessage(['error', this.$t('error_message.no_account_email_address'), this.$t('error_message.check_email_logging_number')])
        }
      } catch {
        this.showMessage(['error', this.$t('error_message.no_account_email_address'), this.$t('error_message.check_email_logging_number')])
      } finally {
        this.loading = false
      }
    },
    async requestPhoneAuthLink () {
      try {
        let resp = await this.$axios.post('/users/request_auth_link/', { phone: this.phoneEmail, language: this.lang })
        this.phoneAuthWaiting = true
        this.phoneAuthInProgress = true
        this.phoneAuthProgressTimer = 300
        const interval = setInterval(() => {
          this.phoneAuthProgressTimer--
          if (this.phoneAuthProgressTimer === 0) {
            this.phoneAuthWaiting = false
            this.phoneAuthSuccess = false
            this.phoneAuthCloseTimer = 5
            const closeInterval = setInterval(() => {
              this.phoneAuthCloseTimer--
              if (this.phoneAuthCloseTimer <= 0) {
                this.phoneAuthInProgress = false
                this.loading = false
                clearInterval(closeInterval)
              }
            }, 1000)
            clearInterval(interval)
          }
        }, 1000)
        this.resendOTPTimer = 30
        const resendInterval = setInterval(() => {
          this.resendOTPTimer--
          if (this.resendOTPTimer === 0) {
            clearInterval(resendInterval)
          }
        }, 1000)
        this.authLinkRecheckCount = 0
        this.manualCheckInterval = setInterval(() => {
          this.authLinkRecheckCount++
          if (this.authLinkRecheckCount >= 60) {
            clearInterval(this.manualCheckInterval)
          }
          this.$axios.get('/users/check_auth_link/', { params: { token: resp.data.token } })
          .then(r => {
            this.phoneAuthSuccess = true
            this.phoneAuthWaiting = false
            this.phoneAuthCloseTimer = 4
            const interval = setInterval(() => {
              this.phoneAuthCloseTimer--
              if (this.phoneAuthCloseTimer === 0) {
                this.completeSignIn(r.data, 'authlink_sms')
                clearInterval(interval)
              }
            }, 1000)
            clearInterval(this.manualCheckInterval)
          })
          .catch(() => {})
        }, 5000)
        this.$wamp.subscribe(`auth-link:${resp.data.token}`, (args, kwArgs) => {
          this.phoneAuthSuccess = true
          this.phoneAuthWaiting = false
          this.phoneAuthCloseTimer = 4
          const interval = setInterval(() => {
            this.phoneAuthCloseTimer--
            if (this.phoneAuthCloseTimer === 0) {
              this.completeSignIn(kwArgs.data, 'authlink_sms')
              clearInterval(interval)
            }
          }, 1000)
        })
      } catch {
        this.showMessage(['error', this.$t('error_message.no_account_phone_number')])
        this.loading = false
      }
    },
    async requestEmailAuthLink () {
      try {
        let resp = await this.$axios.post('/users/request_auth_link/', { email: this.form.email, language: this.lang })
        this.emailAuthWaiting = true
        this.emailAuthInProgress = true
        this.emailAuthProgressTimer = 300
        const interval = setInterval(() => {
          this.emailAuthProgressTimer--
          if (this.emailAuthProgressTimer === 0) {
            this.emailAuthWaiting = false
            this.emailAuthSuccess = false
            this.emailAuthCloseTimer = 5
            const closeInterval = setInterval(() => {
              this.emailAuthCloseTimer--
              if (this.emailAuthCloseTimer <= 0) {
                clearInterval(closeInterval)
              }
            }, 1000)
            clearInterval(interval)
          }
        }, 1000)
        this.authLinkRecheckCount = 0
        this.manualCheckInterval = setInterval(() => {
          this.authLinkRecheckCount++
          if (this.authLinkRecheckCount >= 60) {
            clearInterval(this.manualCheckInterval)
          }
          this.$axios.get('/users/check_auth_link/', { params: { token: resp.data.token } })
          .then(r => {
            this.emailAuthSuccess = true
            this.emailAuthWaiting = false
            this.emailAuthCloseTimer = 4
            const interval = setInterval(() => {
              this.emailAuthCloseTimer--
              if (this.emailAuthCloseTimer === 0) {
                this.completeSignIn(r.data, 'authlink_email')
                clearInterval(interval)
              }
            }, 1000)
            clearInterval(this.manualCheckInterval)
          })
          .catch(() => {})
        }, 5000)
        this.$wamp.subscribe(`auth-link:${resp.data.token}`, (args, kwArgs) => {
          this.emailAuthSuccess = true
          this.emailAuthWaiting = false
          this.emailAuthCloseTimer = 4
          const interval = setInterval(() => {
            this.emailAuthCloseTimer--
            if (this.emailAuthCloseTimer === 0) {
              this.completeSignIn(kwArgs.data, 'authlink_email')
              clearInterval(interval)
            }
          }, 1000)
        })
      } catch {
        this.showMessage(['error', this.$t('error_message.no_account_associated_email')])
      }
    },
    async passwordSignIn () {
      this.passwordSignInLoading = true
      try {
        let resp = await this.$axios.post('/users/token/', this.form)
        this.completeSignIn(resp.data, 'password')
      } catch {
        this.showMessage(['error', this.$t('error_message.invalid_email_or_password')])
      } finally {
        this.passwordSignInLoading = false
      }
    },
    completeSignIn (respData, signInMethod = null) {
      this.$store.commit('user/setUser', respData)
      this.$axios.defaults.headers.common['Authorization'] = `Token ${respData.token}`
      if (signInMethod) {
        this.$logEvent('user.signed_in', { method: signInMethod })
      }
      if (this.isMarketingMerchantApp) {
        this.$router.push('/companies/merchant-app')
      } else if (this.$isLandingPage || !this.$subdomain) {
        this.$router.push('/companies')
      } else {
        let cookieNextPath = Cookies.get('yz_next_path')
        if (cookieNextPath) {
          this.$router.push(cookieNextPath)
          this.$store.commit('ui/setRedirectPath', null)
        } else {
          this.$router.push('/admin/dashboard')
        }
      }
    },
    handleParamUrl () {
      if (this.$route.query.email || this.$route.query.phone) {
        this.phoneEmail = this.$route.query.email || this.$route.query.phone
      }
    },
    async handleGoogleSignInCallback () {
      if (!this.$route.hash) return
      let qs = new URLSearchParams(this.$route.hash.substring(1))
      if (qs.get('state') === 'google' && qs.get('id_token')) {
        this.googleSignInLoading = true
        try {
          let resp = await this.$axios.post('/users/token/', { google_token: qs.get('id_token') })
          this.completeSignIn(resp.data, 'google')
        } catch (err) {
          this.showMessage(['error', this.$t('error_message.no_user_google_id')])
        } finally {
          this.googleSignInLoading = false
        }
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.manualCheckInterval)
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "sign_in_to": "Sign in to",
    "log_in_to": "Log in to",
    "log_in_with_google": "Log In with Google",
    "enter_phone_number_email": "Enter Phone number or Email Address",
    "you_will_receive_email_sms": "You will receive an email or SMS to proceed with signing in.",
    "new_to_yezza": "New to Yezza?",
    "sign_up_now": "Sign up now",
    "check_email_inbox": "Check your e-mail inbox.",
    "check_email_inbox_desc": "We've sent an email with an approval link.",
    "waiting_for_your_approval": "Waiting for your approval",
    "sign_in_approved_continue_in": "Sign in approved. Continue in",
    "approval_link_expired": "Approval link has expired",
    "click_here_to_request": "click here to request again",
    "log_in_with_password": "Log in with password",
    "forgot_password": "Forgot password?",
    "password": "Password",
    "check_your_phone": "Check your phone. We've sent a SMS with an approval link to",
    "sign_in_approved": "Sign in approved",
    "continue_in": "Continue in",
    "sign_in_not_approved": "Sign in not approved in time",
    "closing_in": "Closing in"
  },
  "id": {
    "sign_in_to": "Log in ke",
    "log_in_to": "Log in ke",
    "log_in_with_google": "Log in lewat Google",
    "enter_phone_number_email": "Masukkan nomor HP atau email",
    "you_will_receive_email_sms": "Anda akan menerima email atau SMS untuk Log in.",
    "new_to_yezza": "Pengguna Baru?",
    "sign_up_now": "Daftar sekarang",
    "check_email_inbox": "Periksa email kamu.",
    "check_email_inbox_desc": "Kami telah menghantar email bersama link approval.",
    "waiting_for_your_approval": "Menunggu approval kamu",
    "sign_in_approved_continue_in": "Masuk disetujui. Lanjutkan di",
    "approval_link_expired": "Link approval telah kadaluwarsa",
    "click_here_to_request": "klik di sini untuk meminta lagi",
    "log_in_with_password": "Log in menggunakan kata sandi",
    "forgot_password": "Lupa kata sandi?",
    "password": "Kata sandi",
    "check_your_phone": "Periksa telepon mu. Kami telah mengirim SMS dengan link approval ke",
    "sign_in_approved": "Sign in approved",
    "continue_in": "Continue in",
    "sign_in_not_approved": "Sign in not approved in time",
    "closing_in": "Closing in"
  }
}
</i18n>
